
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPageInfo } from '../../pdf-viewer.service';
import { PdfThumbnailViewportService } from './pdf-thumbnail-viewport.service';

@Component({
  selector: 'ss-pdf-thumbnail-viewport',
  templateUrl: './pdf-thumbnail-viewport.component.html',
  styleUrls: ['./pdf-thumbnail-viewport.component.scss'],
  providers: [
    PdfThumbnailViewportService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfThumbnailViewportComponent {

  // @ViewChildren(CdkVirtualScrollViewport)
  // private _viewportProxyQueryList!: QueryList<CdkVirtualScrollViewport>

  // // readonly virtualElementHeightObs = this._pdfThumbnailViewportService.virtualElementHeightObs;
  // // readonly virtualViewportSubject = this._pdfThumbnailViewportService.virtualViewportSubject;
  readonly pdfDocumentSubject = this._pdfThumbnailViewportService.pdfDocumentSubject;

  @Input() get pdfDocument() {
    return this.pdfDocumentSubject.value;
  }
  set pdfDocument(value) {
    this.pdfDocumentSubject.next(value)
  }


  readonly pageInfosObs = this._pdfThumbnailViewportService.pageInfosObs;
  constructor(
    private _pdfThumbnailViewportService: PdfThumbnailViewportService

  ) {

  }

  // ngOnInit(): void {

  // }

  // ngAfterViewInit() {

  //   this._viewportProxyQueryList
  //     .changes
  //     .pipe(startWith(this._viewportProxyQueryList))
  //     .subscribe((change: QueryList<CdkVirtualScrollViewport>) => {
  //       this.virtualViewportSubject.next(change.first);
  //     })


  // }

  pageSelected(pageInfo: IPageInfo) {

    this._pdfThumbnailViewportService.selectPage(pageInfo);
  }

  trackByIdx(idx: number, pageInfo: IPageInfo) {

    return pageInfo.pageIdx;
  }
}

